import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private _loading = new BehaviorSubject<boolean>(false);
  public loading$ = this._loading.asObservable();

  // Show the loader by incrementing the request count and setting loading to true
  show() {
    this._loading.next(true);
  }

  // Hide the loader when the request count reaches zero
  hide() {
    this._loading.next(false);
  }
}
